module.exports = __webpack_public_path__ + "img/ebo_intro.ffe1f8c3.png";